export default __webpack_public_path__ + "0ef328e5fa93de15742e2fac279a9d08.svg";